import { TimeRangeKind, type TimeRangeConfig } from '@/api/generated/model';
import { resolveNebulyPageTimeRange } from '@/domains/pages/shared/page-time-range';
import { getDateTRangeFromKind } from '@/utils/get-date-range-from-kind';
import { getTimezoneName } from '@/utils/date.util';

/** Default aggregation bucket for Nebuly system pages (PRO-205). */
export function getNebulyPageTimeRangeDefault(now: Date = new Date()): TimeRangeConfig {
  const raw = getDateTRangeFromKind(
    {
      kind: TimeRangeKind['30_days'],
      start: '',
      end: '',
      timezone: getTimezoneName(),
      recompute: true,
    },
    now,
  );

  return resolveNebulyPageTimeRange(raw, now) ?? raw;
}

/** Stable memo key for page time range configs (avoids new-object churn per navigation). */
export function getTimeRangeMemoKey(timeRange: TimeRangeConfig | undefined): string {
  if (!timeRange) return '';
  return `${timeRange.kind}|${timeRange.start}|${timeRange.end}|${timeRange.timezone ?? ''}|${timeRange.recompute ?? ''}`;
}

/** Initial timeframe for Nebuly pages with a report-style filter bar. */
export function getNebulyPageFilterBarDefault(now: Date = new Date()): TimeRangeConfig {
  return getNebulyPageTimeRangeDefault(now);
}
